import { MenuIcon } from '../../constant/social-icon.constant'
import '../../scss/navigation-menu.style.scss';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { getItem, getLocalizedPathFromLocalStorage } from '../../helper/localstorage.helper';
import { menuSections } from '../../constant/menu.constant'
import { ChevronDownIcon, ChevronArrowUpIcon } from '../images/svg/icons';

interface NavigationMenuProps {
  onMenuItemClick?: () => void;
}

const NavigationMenu = ({ onMenuItemClick }: NavigationMenuProps) => {
    const isMobile = useMediaQuery('(max-width: 1199px)');
    const [openSections, setOpenSections] = useState<number[]>([]);
    const [showSocialMedia, setShowSocialMedia] = useState<boolean>(false);    
    const { t } = useTranslation();
    const navigate = useNavigate();
    const getDropdownIcon = (sectionIndex: number) => openSections.includes(sectionIndex) ? ChevronArrowUpIcon : ChevronDownIcon;

    const handleToggle = (idx: number, hasNoLinks: boolean = false) => {
        if (hasNoLinks) return
        setOpenSections((prev) =>
            prev.includes(idx)
                ? prev.filter(i => i !== idx)
                : [...prev, idx]
        );    
    };

    return (
        <div className={`${isMobile ? '' : 'container' }  w-100 bg-light pb-5 navigation-bar text-start z-index-9`}>
            <div className='line-menu'></div>
            <h6
                className="menu-link-discover mb-0 text-start d-xl-none py-4"
            >
                {t('DISCOVER_INVOZIO')}
            </h6>
            <div className="row  width-75 d-flex justify-content-center mx-auto px-0">
                {menuSections.map((section, idx) => (
                    <div
                        className={`col-12 col-xl-3  px-0 ${section.title == 'FREELANCE_SERVICE'? 'd-none  ' : 'd-xl-block px-0'}`}
                        key={section.title}
                    >
                        <div 
                            className='d-flex flex-column padding-40'
                            style={{ cursor: 'pointer' }}
                            onClick={(e) => {
                                // Check if the click target is a link (to avoid interfering with individual link clicks)
                                if ((e.target as HTMLElement).tagName === 'A' || (e.target as HTMLElement).closest('a')) {
                                    return;
                                }
                                
                                if (isMobile && section.links && section.links.length > 0) {
                                    handleToggle(idx, false);
                                } else if (section.links && section.links.length > 0) {
                                    // Create section-specific navigation logic
                                    let targetRoute;
                                    if (section.title === 'FREELANCE_INVOICING') {
                                        // Navigate to the freelancing guide as the main page
                                        const freelancingGuideLink = section.links.find(link => link.key === 'FREELANCING_GUIDE');
                                        if (freelancingGuideLink) {
                                            targetRoute = {
                                                'sv-se': freelancingGuideLink.sv,
                                                'en-us': freelancingGuideLink.en
                                            };
                                        }
                                    }
                                    
                                    // Fallback to first link if no specific route is defined
                                    if (!targetRoute) {
                                        targetRoute = {
                                            'sv-se': section.links[0].sv,
                                            'en-us': section.links[0].en
                                        };
                                    }
                                    
                                    navigate(getLocalizedPathFromLocalStorage(
                                        { get: (key: string) => getItem(key) ?? null },
                                        targetRoute
                                    ));
                                }
                            }}
                        >
                            <div className='d-flex justify-content-between align-items-start'>
                                <h6
                                    className={`mb-0 ${isMobile ? ' menu-link' : ' navigation_bar_title'}`}
                                >
                                    {t(section.title)}
                                </h6>
                                <img 
                                    src={getDropdownIcon(idx)} 
                                    className={`py-1 ${!section.links || section.links.length === 0 || !isMobile ? 'd-none' : 'd-xl-block'}`} 
                                    alt="" 
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        if (isMobile) {
                                            handleToggle(idx, !section.links || section.links.length === 0);
                                        }
                                    }}
                                />
                            </div>
                            {(!isMobile || openSections.includes(idx)) && (
                                <ul className="list-unstyled mb-0">
                                    {section.links.map(link => (
                                        <li key={link.key} className='mb-0 pb-3 px-0'>
                                            <a
                                                href="#"
                                                className={` ${isMobile ? ' navigation_bar_title' : ' menu-link mr-4'}`}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    onMenuItemClick?.();
                                                    navigate(
                                                        getLocalizedPathFromLocalStorage(
                                                            { get: (key: string) => getItem(key) ?? null },
                                                            {
                                                                'sv-se': link.sv,
                                                                'en-us': link.en
                                                            }
                                                        )
                                                    );
                                                }}
                                            >
                                                {t(link.key)}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                        {idx === menuSections.length - 1 && (
                            <>
                                <div className='d-flex justify-content-between align-items-start'>
                                    <h6 
                                        className={`mb-0  ${isMobile ? 'menu-link mb-0' : 'navigation_bar_title padding-48'}`}
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => {
                                            if (isMobile) {
                                                setShowSocialMedia((prev) => !prev);
                                            }
                                        }}
                                    >
                                        {t('SOCIAL_MEDIA')}
                                    </h6>
                                    <img 
                                        src={showSocialMedia ? ChevronArrowUpIcon : ChevronDownIcon} 
                                        className={`py-1 ${!isMobile ? 'd-none': ''}`} 
                                        alt="" 
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setShowSocialMedia((prev) => !prev);
                                        }}
                                    />
                                </div>
                                {(showSocialMedia || !isMobile) &&
                                    <div className="d-flex gap-3">
                                        {MenuIcon.map(s => (
                                            <a
                                                key={s.ariaLabel}
                                                href={s.link}
                                                target="_blank"
                                                rel="noreferrer"
                                                aria-label={s.ariaLabel}
                                            >
                                                <img src={s.icon} alt={t(s.ariaLabel)} className="mr-2" />
                                            </a>
                                        ))}
                                    </div>
                                }
                            </>
                        )}

                    </div>
                ))}
                <div className='line-menu'></div>

            </div>
        </div>
    );
};

export default NavigationMenu;
